/**
 * 卡bin 校验
*/
const cardMetaData = {
  AMEX: /^3[47]/,
  DINERSCLUB: /^(36|38|30[0-5])/,
  DISCOVER: /^(6011|65|64[4-9])/,
  JCB: /^(?:2131|1800|35[0-9]{3})/,
  MASTERCARD: /^5[1-5]/,
  VISA: /^4/,
  UNIONPAY: /^62\d{4}$/,
};
// cardTypes为目前支持的cardType(卡类型),
// const cardTypes = [
//   'AMEX',
//   'DINERSCLUB',
//   'DISCOVER',
//   'JCB',
//   'MASTERCARD',
//   'VISA',
// ];

const getTypeByPattern = (number, cardTypes) => {
  const newNum = number.replace(/\s*/g, '');
  var result = void 0;
  cardTypes.some(function(type) {
    // console.log('type', type.toLocaleUpperCase());
    var metaData = cardMetaData[type.toLocaleUpperCase()];
    if (metaData && metaData.test(newNum)) {
      result = type;
      return true;
    }
    return false;
  });
  return result;
};
export default getTypeByPattern;
